import { render, staticRenderFns } from "./NewPaymentsPayoneerCreateAdmin.vue?vue&type=template&id=24df349a&scoped=true"
import script from "./NewPaymentsPayoneerCreateAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerCreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df349a",
  null
  
)

export default component.exports